import { Modal } from "reactstrap";

const ImageShowModal = ({ isOpen, toggle, imageSrc }) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <img
        src={imageSrc}
        alt="Full Preview"
        className="img-fluid custom-height-80vh max-w-100 rounded object-fit-cover"
      />
    </Modal>
  );
};

export default ImageShowModal;
